import { Observable, of,Subject } from "rxjs";

export class AuthorityService {
    queryOperationAuthority(operationIds: Array<string>): Observable<Map<string, boolean>>{
        var queryResult = new Map<string, boolean>();
        var i=0;
        for(var j=0; j<operationIds.length; j++) {
            queryResult.set(operationIds[j], i%2==0? true:false);
            i++;            
        }

        var dummyResult = new Subject<Map<string, boolean>>();
        setTimeout(() => {
            dummyResult.next(queryResult);
        }, 0);

        return dummyResult;
    }
}
